import * as React from "react";
function SvgFamily(props, svgRef) {
    return (
        <svg
            width="1em"
            height="1em"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={svgRef}
            {...props}
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M12.445 17.914C13.017 16.374 14.1 15 16 15c1.523 0 2.49.856 3.128 1.99.659 1.17.872 2.5.872 3.01h2c0-.823-.287-2.494-1.128-3.99C20.009 14.477 18.477 13 16 13c-2.559 0-4.08 1.547-4.937 3.134A4.65 4.65 0 008 15c-1.705 0-2.971.863-3.78 1.875C3.434 17.855 3 19.07 3 20h2c0-.404.232-1.189.781-1.875C6.305 17.47 7.039 17 8.001 17c.96 0 1.694.47 2.218 1.125.55.686.781 1.471.781 1.875h2c0-.62-.193-1.367-.555-2.086zM8 12a1 1 0 100-2 1 1 0 000 2zm0 2a3 3 0 100-6 3 3 0 000 6zm10-6a2 2 0 11-4 0 2 2 0 014 0zm2 0a4 4 0 11-8 0 4 4 0 018 0z"
                fill="currentcolor"
            />
        </svg>
    );
}
const ForwardRef = React.forwardRef(SvgFamily);
export default ForwardRef;
